import React from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import { withRouter } from "react-router";
import WelcomePage from "Portal/CallForPapersForm/View/WelcomePage";

import SessionPage from "./GroupPage";
import ParticipantsPage from "./ContactPage";
import LoginPage from "./LoginPage";
import ConfirmationPage from "./ConfirmationPage";

import { getters } from "../model";

import { STEPS } from "../constants";

const decorate = R.compose(
  connect(state => ({
    activeStep: getters.activeStep(state)
  })),
  withRouter
);

const getPageView = activeStep => {
  return R.propOr(WelcomePage, activeStep, {
    [STEPS.WELCOME]: WelcomePage,
    [STEPS.AUTH]: LoginPage,
    [STEPS.SESSION]: SessionPage,
    [STEPS.PARTICIPANTS]: ParticipantsPage,
    [STEPS.CONFIRMATION]: ConfirmationPage
  });
};

const Page = ({ handlers, mobile, activeStep }) => {
  const PageView = getPageView(activeStep);
  return <PageView mobile={mobile} handlers={handlers} />;
};

export default decorate(Page);
